import { create } from 'zustand';

export type VaultFileAvailability = 'available' | 'no-access' | 'removed';

export interface VaultOpenOptions {
  conversationId?: string;
}

export interface VaultLinks {
  availability(fileId: string): Promise<VaultFileAvailability>;
  download(fileId: string): Promise<void>;
  open(fileId: string, options?: VaultOpenOptions): void;
}

export type VaultLinksFlag = 'pending' | 'enabled' | 'disabled';

interface VaultLinksState {
  links: VaultLinks | null;
  flag: VaultLinksFlag;
}

const useVaultLinksStore = create<VaultLinksState>()(() => ({
  links: null,
  flag: 'pending',
}));

function activeLinks(state: VaultLinksState): VaultLinks | null {
  return state.flag === 'enabled' ? state.links : null;
}

export function provideVaultLinks(links: VaultLinks | null): void {
  useVaultLinksStore.setState({ links });
}

export function setVaultLinksEnabled(enabled: boolean): void {
  useVaultLinksStore.setState({ flag: enabled ? 'enabled' : 'disabled' });
}

export function resetVaultLinks(): void {
  useVaultLinksStore.setState({ links: null, flag: 'pending' });
}

export function getVaultLinks(): VaultLinks | null {
  return activeLinks(useVaultLinksStore.getState());
}

export function useVaultLinks(): VaultLinks | null {
  return useVaultLinksStore(activeLinks);
}
